
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ProfessionalInformation extends Vue {
  @Prop(Object) user!: any;
  @Prop(Boolean) firstJob!: boolean;
  @Prop(Boolean) offer!: boolean;
  @Prop(Boolean) work!: boolean;
  @Prop(Boolean) withCheck!: boolean;
  @Prop(Boolean) modality!: boolean;
  @Prop(Boolean) withTag!: boolean;
  optionsArea = [];
  optionsPlaces = [];
  optionsSlider = {
    interval: 1,
    dotSize: 20,
    max: 200000
  };
  msjSlot = "Escribe una ubicacion";
  slider_rank = [
    (this.user && this.user.lowest_expected_salary) || 0,
    (this.user && this.user.highest_expected_salary) || 200000
  ];

  async fetchOptions(search: any, loading: any) {
    if (search.length > 2) {
      loading(true);
      const response = await (this as any).$root._get(
        `misc/locations?q=${search}&addp=1`,
        {}
      );
      (this as any).optionsPlaces = response;
      loading(false);
      if (response.length === 0) {
        (this as any).msjSlot = "Lo sentimos, no hay resultados.";
      }
    } else {
      this.msjSlot = "Escribe una ubicacion";
    }
  }

  changeSalary() {
    let value = (this as any).$refs.slider.getValue();
    (this as any).user.lowest_expected_salary = value[0];
    (this as any).user.highest_expected_salary = value[1];
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }

  async mounted() {
    const _this: any = this;
    const response = await _this.$root._get("area", {});
    _this.optionsArea = response.data.map((item: any) => {
      return { ...item, label: item.description };
    });

    if (_this.user.areaId)
      _this.user.area = _this.optionsArea.find(
        (i: any) => i.id === _this.user.areaId
      );

    if (_this.user.locationId) {
      const response = await (this as any).$root._get(
        `misc/locations?id=${_this.user.locationId}`,
        {}
      );
      (this as any).optionsPlaces = response;
      _this.user.desired_place_lat = _this.optionsPlaces.find(
        (i: any) => i.id === _this.user.locationId
      );
    }
  }

  checkFullTime() {
    if (!this.user.is_full_time) this.user.is_part_time = false;
  }

  checkPartTime() {
    if (!this.user.is_part_time) this.user.is_full_time = false;
  }
}
